module.exports = __webpack_public_path__ + "static/media/IMG_4579 high island from rear - Copy.764dc997.JPG";